// extracted by mini-css-extract-plugin
export var button = "_cv-4";
export var hasDarkBackground = "_cv-7";
export var hasLightBackground = "_cv-6";
export var iconWrapper = "_cv-0";
export var large = "_cv-2";
export var medium = "_cv-1";
export var small = "_cv-5";
export var xsmall = "_cv-3";